import { generatePath } from "react-router";
import { DriverProfileDto, FleetDto, Maybe, TagCategoryDto, TagDto, VerificationTypeDto } from "generated/graphql";
import { EntityPageMode, getCreatePathTemplate, getEntityPathTemplate } from "navigation/utils";

export function generateCreatePath(basePath: string) {
  return generatePath(getCreatePathTemplate(basePath), { mode: EntityPageMode.create });
}

export function generateViewPath<T extends { id?: Maybe<number> }>(basePath: string, params: T | undefined | null) {
  if (!params || !params?.id) {
    return "#";
  }
  return generatePath(getEntityPathTemplate(basePath), {
    ...params,
    mode: EntityPageMode.view,
  } as any);
}

export function generateEditPath<T extends { id?: Maybe<number> }>(basePath: string, params: T | undefined | null) {
  if (!params || !params?.id) {
    return "#";
  }
  return generatePath(getEntityPathTemplate(basePath), {
    ...params,
    mode: EntityPageMode.edit,
  } as any);
}

export const links = {
  support: "https://tecorien.screenconnect.com/",
  appRoot: "/",
  accessDenied: "/403",
  profile: "/profile",
  driverProfile: "/drivers",
  tag: "/tags",
  generateFile: "/generate-file",
  tagCategory: "/tag-categories",
  verificationType: "/verification-types",
  fleet: "/fleets",
  exportFiles: "/export-files",
  fileRequests: "/file-requests",
  appendToLOP: "/append-to-lop",
  public: "/public",
  publicAttachment: "/public/attachment",
  publicCLCodeOfConduct: "/public/cl-code-of-conduct",
  publicPACEOrientationAndDriverTraining: "/public/pace-orientation-and-driver-training",
};

export const getLink = {
  getDriverProfilesLink: links.driverProfile,
  getCreateDriverProfileLink: generateCreatePath(links.driverProfile),
  getDriverProfileLink: (driverProfile: Partial<DriverProfileDto>) => generateViewPath(links.driverProfile, driverProfile),

  getTagsLink: links.tag,
  getCreateTagLink: generateCreatePath(links.tag),
  getTagLink: (tag: Partial<TagDto>) => generateViewPath(links.tag, tag),

  getTagCategoriesLink: links.tagCategory,
  getCreateTagCategoryLink: generateCreatePath(links.tagCategory),
  getTagCategoryLink: (tagCategory: Partial<TagCategoryDto>) => generateViewPath(links.tagCategory, tagCategory),

  getVerificationTypesLink: links.verificationType,
  getCreateVerificationTypeLink: generateCreatePath(links.verificationType),
  getVerificationTypeLink: (verificationType: Partial<VerificationTypeDto>) => generateViewPath(links.verificationType, verificationType),

  getFleetsLink: links.fleet,
  getCreateFleetLink: generateCreatePath(links.fleet),
  getFleetLink: (fleet: Partial<FleetDto>) => generateViewPath(links.fleet, fleet),

  getGenerateFileLink: links.generateFile,
  getCreateGenerateFileLink: generateCreatePath(links.generateFile),
};


Object.freeze(links);
Object.freeze(getLink);
